import React from 'react';
import Hero from '../../components/pages/MarketAnalysis/Hero/Hero';
import Main from '../../components/pages/MarketAnalysis/Main/Main';
import Posts from '../../components/pages/MarketAnalysis/Posts/Posts';
import MarketInsights from '../../components/pages/MarketAnalysis/MarketInsights/MarketInsights';
import InsightToStrategy from '../../components/pages/MarketAnalysis/InsightToStrategy/InsightToStrategy';

const MarketAnalysis = () => {
  return (
    <div>
      <Hero />
      <Main />
      <Posts />
      <MarketInsights />
      <InsightToStrategy />
    </div>
  );
};

export default MarketAnalysis;
